$(document).ready(function(){

  $('.m-menu').click(function(){
    if ($('body').hasClass('m-menu-open')){
      $('body').removeClass('m-menu-open');
    }else{
      $('body').addClass('m-menu-open');
    }
  });

  function toggleListView(index){
    if($('.right').hasClass('listview')){
      $('.right').removeClass('listview');
      // add slick
      $('.works').slick();
      if(index != -1) {
        $('.works').slick("goTo", index, true);
      }
    }else{
      $('.right').addClass('listview');
      // remove slick
      if($('.works').hasClass('slick-initialized')){
        $('.works').slick('unslick');
      }
    }
  }

  $('.list').click(function(){
    toggleListView(-1)
  });

  // go from thumb to slick view
  $('.listview .work').on("click", function(e){
    e.stopPropagation();
    var idx = $(this).data("workindex");
    toggleListView(idx);

  });

  // start slicking
  $('.works').slick({
    speed: 0,
    fade: true
  });

  $('.works').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.work-title').html('')
  });

  $('.works').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.work-title').html($('.slick-current').find('.title').html())
  });


  function resizeImg() {
    var wHeight = $( window ).height();
  //   aspectRatio = ( oldWidth / oldHeight )
    var maxHeight = wHeight - 200;

    $slickSlider = $('.works');
    $slickSlider.find('.slick-slide').height('auto');

    $slickSlider.find('.slick-slide img').css('width', 'auto');
    $slickSlider.find('.slick-slide img').css('max-height', maxHeight + 'px');

  }

  $(window).on('load', function(){
    //console.log('load');
    resizeImg();
  })
  $(window).on('resize', function(){
    resizeImg();
  })

  $('iframe[src*="youtube"]').parent().fitVids();

  // $(window).on('load', function(){
  //   var wHeight = $( window ).height();
  //   aspectRatio = ( oldWidth / oldHeight )
  //   $('.slick-slide img').height(wHeight - 200);
  // });

  // $(window).on('resize', function(){
  //   alto = $( window ).height();
  //   $('.slick-slide img').height(alto - 200);
  // });

});